import { unstable_composeClasses as composeClasses } from '@ori-ui/mui-bundle/base';
import { styled, useThemeProps } from '@ori-ui/mui-bundle/material';
import clsx from 'clsx';
import { forwardRef } from 'react';
import useSuspenseImage from '../useSuspenseImage';
import { getSuspenseImageUtilityClass } from './suspenseImageClasses';
import { jsx as _jsx } from "react/jsx-runtime";
export const getSuspenseImageSlots = _ => ({
  root: ['root']
});
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getSuspenseImageSlots(ownerState);
  return composeClasses(slots, getSuspenseImageUtilityClass, classes);
};
const SuspenseImageRoot = styled('img', {
  name: 'MuiOriSuspenseImage',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})({});
export const SuspenseImage = /*#__PURE__*/forwardRef((inProps, ref) => {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiOriSuspenseImage'
  });
  const {
    component,
    src,
    srcSet,
    className,
    shouldThrowError,
    errorFallback = null,
    onerror,
    onload,
    ...otherProps
  } = props;
  const {
    isLoaded,
    error
  } = useSuspenseImage({
    shouldThrowError,
    src,
    srcSet,
    onerror,
    onload
  });
  const ownerState = {
    ...props,
    isLoaded,
    error,
    shouldThrowError
  };
  const classes = useUtilityClasses(ownerState);
  if (error !== undefined) {
    return errorFallback;
  }
  return /*#__PURE__*/_jsx(SuspenseImageRoot, {
    ref: ref,
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    src: src,
    srcSet: srcSet,
    ...otherProps
  });
});
export default SuspenseImage;
//# sourceMappingURL=SuspenseImage.js.map